import { Component, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { switchMap, of } from 'rxjs';
import { ToasterMessages } from 'src/app/shared/constants/constants';
import { OnboardingProgressService } from 'src/app/shared/service/onboarding-progress/onboarding-progress.service';
import { OnboardingSubmitService } from 'src/app/shared/service/onboarding-submit/onboarding-submit.service';
import { PortRequestFormServiceService } from 'src/app/shared/service/port-request-FormService/port-request-form.service.service';

@Component({
  selector: 'app-uploading-files',
  templateUrl: './uploading-files.component.html',
  styleUrls: ['./uploading-files.component.scss'],
})
export class UploadingFilesComponent {
  userName: any;
  selectedQ88File: File | null = null;
  selectedTechFile: File | any = null;
  selectedJsonFile: File | null = null;
  selectedSetting: 'alerts' | 'vessel' = 'alerts';
  showVesselUpload = false;
  showNotificationSettings = true;
  @ViewChild('q88FileInput') q88FileInput!: ElementRef;
  @ViewChild('techFileInput') techFileInput!: ElementRef;
  @ViewChild('jsonFileInput') jsonFileInput!: ElementRef;
  vessels = [
    { name: 'Vessel A', imo: 9817145, thresholdSpeed: 12 },
    { name: 'Vessel B', imo: 9273442, thresholdSpeed: 15 },
  ];
  showTechnicalFile = true;
  constructor(
    private toastr: ToastrService,
    private portRequestformService: PortRequestFormServiceService,
    private onboardingProgressService: OnboardingProgressService,
    private onboardingSubmitService: OnboardingSubmitService,
    private router: Router,
  ) { }
  ngOnInit() {
    this.userName = localStorage.getItem('username');
    const nav = (history.state || {}) as {
      fromQ88?: boolean;
      fromOnboardingForm?: boolean;
      fromOnboardingProgress?: boolean;
      imo?: string;
    };

    const fromQuestionnaireUpload =
      nav.fromOnboardingForm === true || nav.fromQ88 === true;
    const fromPortOnboarding =
      nav.fromOnboardingProgress === true && !!nav.imo;

    if (fromQuestionnaireUpload || fromPortOnboarding) {
      this.showVesselUpload = true;
      this.showNotificationSettings = false;
      this.selectedSetting = 'vessel';
      this.showTechnicalFile = fromPortOnboarding;
      return;
    }

    this.showVesselUpload = false;
    this.showNotificationSettings = true;
    this.selectedSetting = 'alerts';
  }



  onQ88FileSelected(event: any) {
    const file = event.target.files[0];
    if (file && file.name.toLowerCase().endsWith('.pdf')) {
      this.selectedQ88File = file;
    } else {
      this.toastr.warning('Only PDF files are allowed for Q88.');
    }
  }

  onJsonFileSelected(event: any) {
    const file = event.target.files[0];
    if (file && file.name.toLowerCase().endsWith('.json')) {
      this.selectedJsonFile = file;
    } else if (file) {
      this.toastr.warning('Only JSON files are allowed for Q88 data.');
    }
  }

  removeJsonFile() {
    this.selectedJsonFile = null;
    if (this.jsonFileInput) {
      this.jsonFileInput.nativeElement.value = '';
    }
  }

  onTechFileSelected(event: any) {
    const file = event.target.files[0];
    const validExtensions = ['xlsx', 'xls', 'xlsm', 'csv'];
    const ext = file.name.split('.').pop()?.toLowerCase();
    if (file && validExtensions.includes(ext || '')) {
      this.selectedTechFile = file;
    } else {
      this.toastr.warning('Invalid format for Technical Design File.');
    }
  }

  submitClick() {
    if (!this.selectedQ88File) {
      this.toastr.warning('Please upload  the Q88 file.');
      return;
    }
    this.portRequestformService
      .uploadFiles(this.selectedTechFile, this.selectedQ88File, this.selectedJsonFile)
      .pipe(
        switchMap(() => {
          const nav = history.state as {
            fromOnboardingProgress?: boolean;
            imo?: string;
          };
          if (!nav?.fromOnboardingProgress || !nav?.imo) {
            return of(null);
          }

          return this.onboardingSubmitService.submitModuleOnboarding('port', {
            moduleData: {
              q88_uploaded: true,
              technical_file_uploaded: !!this.selectedTechFile,
            },
            vesselContext: this.onboardingSubmitService.resolveVesselContext(
              nav.imo,
            ),
            successMessage: 'Port Performance onboarding submitted successfully',
          });
        }),
      )
      .subscribe({
        next: (message) => {
          this.toastr.success(ToasterMessages.FilesUpload);
          if (message) {
            this.toastr.success(message);
          }
          this.handleSuccessfulUpload();
        },
        error: (err) => {
          const backendErr = err?.error?.error || err?.error?.message;
          this.toastr.error(
            backendErr ||
              this.onboardingSubmitService.extractErrorMessage(
                err,
                ToasterMessages.Error,
              ),
          );
        },
      });
  }

  saveAlert(vessel: any) {
    console.log('Saving alert for:', vessel);
    // Call API to save threshold speed
  }

  onTabChange(index: number) {
    this.selectedSetting = index === 0 ? 'alerts' : 'vessel';
  }

  goBack(): void {
    const nav = history.state as {
      fromOnboardingProgress?: boolean;
      fromQ88?: boolean;
      fromOnboardingForm?: boolean;
      imo?: string;
    };

    if (nav?.fromOnboardingProgress && nav?.imo) {
      this.router.navigate(['/vp-onboardingForm'], {
        state: { reopenOnboardingProgress: true, imo: nav.imo },
      });
      return;
    }

    if (nav?.fromQ88 || nav?.fromOnboardingForm) {
      this.router.navigate(['/vp-onboardingForm']);
      return;
    }

    this.router.navigate(['/pc-home']);
  }

  private handleSuccessfulUpload(): void {
    const nav = history.state as {
      fromOnboardingProgress?: boolean;
      fromQ88?: boolean;
      fromOnboardingForm?: boolean;
      imo?: string;
    };

    if (nav?.fromOnboardingProgress && nav?.imo) {
      this.onboardingProgressService.markModuleCompleted(nav.imo, 'port');
      this.router.navigate(['/vp-onboardingForm'], {
        state: { reopenOnboardingProgress: true, imo: nav.imo },
      });
      return;
    }

    if (nav?.fromQ88 || nav?.fromOnboardingForm) {
      this.router.navigate(['/vp-onboardingForm']);
    }
  }
}
